(function () {
    'use strict';
    var m = angular.module('common');
    m.directive('authorizedRolesRemove', ["$rootScope", "$compile", function ($rootScope, $compile) {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs, ctrl) {
                if (attrs.authorizedRolesRemove) {
                    var roles = attrs.authorizedRolesRemove.replace(/\s/g, '').split(',');
                    if (!roles.includes($rootScope.userRole)) {
                        elem.remove();
                    }
                }
            }
        };
    }]);
    // This directive:
    // 1. Disables pointer-events on current element
    // 2. makes a div around the current element that has the title "Not Authorized" + adds a not-allowed cursor
    // It is basically a way of disabling interactivity with the element because the user is not authorized
    m.directive('authorizedRolesDisable', ["$compile", "$rootScope", function ($compile, $rootScope) {
        return {
            restrict: 'A',
            // transclude: true,
            link: function (scope, element, attrs) {
                if (attrs.authorizedRolesDisable) {
                    var roles = attrs.authorizedRolesDisable.replace(/\s/g, '').split(',');
                    if (!roles.includes($rootScope.userRole)) {
                        element.addClass('disabled-interactivity');
                        element.removeAttr('authorized-roles-disable');
                        element.removeAttr('href');
                        element.removeAttr('ng-click');
                        element.removeAttr('qtip2');
                        element.attr('title', 'Not Authorized');
                        element.attr('disabled', true);
                        $compile(element)(scope);
                    }
                }
            }
        };
    }]);
}());